import { type ReduxUser, type Comment, type Reply } from 'models';

export const canEditComment = ({ viewer, comment }: { viewer: ReduxUser; comment: Comment | Reply }) => {
  return viewer.id === comment.author.id;
};
